import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const animations = {
  accordions: () => import("./../animations/accordions"),
};
export const app = () => {
  const accordionsGroup = document.querySelectorAll(".yacht__accordions");
  console.log(accordionsGroup);
  if (accordionsGroup.length > 0) {
    for (const group of accordionsGroup) {
      const accordions = group.querySelectorAll(".yacht__accordion");

      if (accordions.length > 0) {
        for (const [i, accordion] of accordions.entries()) {
          let isOpen = false;

          const trigger = accordion.querySelector(".yacht__accordion__trigger"),
            container = accordion.querySelector(".yacht__accordion__content");

          trigger.addEventListener("click", () => {
            isOpen = !isOpen;

            animations.accordions().then((module) => {
              module.accordions(
                isOpen,
                container,
                0.7,
                null,
                null,
                null,
                trigger
              );
              accordion.classList.toggle("yacht__accordion--open");
            });
          });
        }
      }
    }
  }
};
